import { Component, Input } from '@angular/core';
import { Activity } from 'ng2-app/modules/activity/models/activity/activity.model';

@Component({
    selector: 'activity-row-doc-rejected',
    templateUrl: 'activity-row-doc-rejected.component.html',
    styles: [],
    standalone: false
})
export class ActivityRowDocRejectedComponent {
    @Input() activity: Activity;
    constructor() {}
}
